"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
var _default = exports.default = {
  name: 'WeWorkLoginPane',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var callbackUrl = process.env.VUE_APP_REDIRECT_URI;
    var appId = process.env.VUE_APP_WEWORK_CORP_ID;
    var agentId = process.env.VUE_APP_WEWORK_AGENT_ID;
    console.log(process.env.NODE_ENV);
    console.log(process.env.ENV);
    var redirectUrl = encodeURIComponent(callbackUrl);
    console.log(callbackUrl);
    console.log(redirectUrl);
    new window.WwLogin({
      "id": "wx_reg",
      "appid": appId,
      "agentid": agentId,
      "redirect_uri": redirectUrl,
      "state": "state"
    });
  }
};